import ApiRequestService from "services/ApiRequestService";
import ApiService from "./ApiService";

function createSearchRequest(requestCount, pageNumber, searchTerm, sortField, sortDir, filters) {

    return {
        "requestCount": requestCount,
        "pageNumber": pageNumber,
        "searchTerm": searchTerm,
        "sortField": sortField,
        "sortDirection": sortDir,
        "filters": filters.map((f) => { return { key: f.name, value: f.value } })
    };
}

function sortActivitiesAndGetEndpoint(templateType, template) {
    let endpoint = "";

    switch (templateType) {
        case "MANUALENTRYMULTI":
            endpoint = "MultiDay";
            template.days = template.days?.sort((a, b) => a.dayNumber - b.dayNumber);
            break;
        case "STATWEEKHOLIDAY":
        case "STATWEEKSICKNESS":
            endpoint = "Statutory";
            template.statutoryType = templateType;
            template.dayNumbers = template.dayNumbers?.sort((a, b) => a - b);
            break;
        default:
            endpoint = "SingleDay";
            break;
    }
    return endpoint;
}

export const ManualEntryService = {
    getOptions() {
        return new Promise((resolve, reject) => {
            ApiService.get('/employee/options/ManualEntries').then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                });
        });
    },
    checkForInfringments(request) {
        return ApiRequestService.post('employee', `ManualEntryTemplates/Infringements`, request);
    },
    getTemplateList(pageSize, pageNumber, searchTerm, sortField, sortDir, filters) {
        var searchRequest = createSearchRequest(pageSize, pageNumber, searchTerm, sortField, sortDir, filters ?? []);

        return ApiRequestService.post('employee', `ManualEntryTemplates/Search`, searchRequest);
    },
    toggleTemplateVisibility(templateId, request) {
        return ApiRequestService.patch('employee', `ManualEntryTemplates/${templateId}/Visibility`, request);
    },
    cloneTemplate(templateId, request) {
        return ApiRequestService.post('employee', `ManualEntryTemplates/${templateId}/Clone`, request);
    },
    deleteTemplate(templateId) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`/employee/ManualEntryTemplates/${templateId}`).then(
                (result) => {
                    resolve(result.data);
                },
                () => {
                    reject("Unable to delete the template, please try again.");
                });
        });
    },
    createTemplate(templateType, request) {
        let endpoint = sortActivitiesAndGetEndpoint(templateType, request);

        return new Promise((resolve, reject) => {
			ApiService.post(`/employee/ManualEntryTemplates/${endpoint}`, request).then(
				(result) => {
					resolve(result.data);
				},
				(error) => {
					reject(error);
				});
		});
    },
    updateTemplate(templateType, id, request) {
        let endpoint = sortActivitiesAndGetEndpoint(templateType, request);

        return new Promise((resolve, reject) => {
			ApiService.put(`/employee/ManualEntryTemplates/${endpoint}/${id}`, request).then(
				(result) => {
					resolve(result.data);
				},
				(error) => {
					reject(error);
				});
		});
    },
    getTemplate(templateType, id) {
        const normalizedType = templateType?.toUpperCase();
        let endpoint = "";
        switch (normalizedType) {
            case "MANUALENTRYMULTI":
                endpoint = "MultiDay";
                break;
            case "STATWEEKHOLIDAY":
            case "STATWEEKSICKNESS":
                endpoint = "Statutory";
                break;
            default:
                endpoint = "SingleDay";
                break;
        }

        return new Promise((resolve, reject) => {
			ApiService.get(`/employee/ManualEntryTemplates/${endpoint}/${id}`).then(
				(result) => {
                    var template = result.data;
                    switch (normalizedType) {
                        case "MANUALENTRYMULTI":
                            template.days = template.days.sort((a, b) => a.dayNumber - b.dayNumber);
                            break;
                        case "STATWEEKHOLIDAY":
                        case "STATWEEKSICKNESS":
                            template.dayNumbers = template.dayNumbers.sort((a, b) => a - b);
                            break;
                        default:
                            template.activities = template.activities.sort((a, b) => a.orderId - b.orderId);
                            break;
                    }

					resolve(template);
				},
				(error) => {
					reject(error);
				});
		});
    },
    timeStringToNumeric(timeString) {
        if (timeString == null) return 0;

        const timeParts = timeString.split(':');

        if (timeParts.length !== 2) {
            return 0;
        }

        return (parseInt(timeParts[0], 10) * 60) + parseInt(timeParts[1], 10);
    },
    timeToString(time) {
        const minutesInHour = 60;
        const minutesInDay = 1440;

        time = time % minutesInDay;

        const hours = Math.floor(time / minutesInHour);
        const minutes = time % minutesInHour;

        return hours.toString().padStart(2, "0") + ":" + minutes.toString().padStart(2, "0");
    },
    groupInfringementCodes(infringements) {
    
        if(infringements == null) {
            return '';
        }

        const groupedInfringements = infringements.reduce(function(accumulator, infringement) {
            let code = accumulator[infringement.code] ??= [];
            code.push(infringement);
            return accumulator;
        }, {});

        return Object.entries(groupedInfringements).map(([infringementKey, infringementArr]) => {
            return `${infringementKey}${infringementArr.length > 1 ? ' (x' + infringementArr.length + ')' : ''}`;
        }).join(', ');

    }
}

